import { useParams, useSearchParams } from "react-router-dom";
import Add from "../components/user/Add";
import Content from "../components/user/Content";
import { CommmonBoxLayout, CommonLayout } from "../style/common";

export default function UserDetail() {
  const { idx } = useParams<{ idx: string }>();
  const [searchParams] = useSearchParams();
  const isEditPage = searchParams.get("mode") === "edit";

  return (
    <CommonLayout>
      <CommmonBoxLayout>
        {idx && (idx === "add" || isEditPage ? <Add /> : <Content useIdx={idx} />)}
      </CommmonBoxLayout>
    </CommonLayout>
  );
}
